<template>
  <bimContainer class="about-container">
    <bimCol xxl=10 xl=11 sm=12 class="mx-auto">
      <BlockHead class="d-block mx-auto my-12" />
      <BlockTabs @changeTab="setUrlTab" :currentTab="tab" :tabs="tabs" />

      <BlockContentAbout v-show="tab === 'about'" key="about" />
      <BlockContentJob v-show="tab === 'job'" key="job" />
    </bimCol>
  </bimContainer>
</template>

<script>
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"

import BlockHead from "./components/BlockHead"
import BlockTabs from "./components/BlockTabs"

// Блоки контента
import BlockContentAbout from "./components/BlockContentAbout"
import BlockContentJob from "./components/BlockContentJob"

// Иконки мобильныхъ табов
import AboutIcon from "./icons/AboutIcon"
import JobIcon from "./icons/JobIcon"

import { URLParams } from "@/utils/url.js"
const urlParams = new URLParams(window.location.href)
export default {
  name: "LandingAbout",
  components: {
    bimCol,
    bimContainer,

    BlockHead,
    BlockTabs,
    BlockContentAbout,
    BlockContentJob,
  },

  data() {
    return {
      tab: "about",
      tabs: [
        {
          value: "about",
          label: "О компании",
          adaptive: {
            width: 50,
            icon: AboutIcon,
            iconPadding: '0 6px 0 10px',
          }
        },
        {
          value: "job",
          label: "Вакансии",
          adaptive: {
            width: 50,
            icon: JobIcon,
            iconPadding: '0 14px 0 18px',
          }
        }
      ]
    }
  },
  created() {
    const tab = urlParams.get("tab") || "about"
    this.setUrlTab(tab)
  },
  methods: {
    setUrlTab(tab) {
      urlParams.set("tab", tab)
      this.tab = tab
    },
  }
}
</script>

<style lang="scss" scoped>
.about-container {
  padding-bottom: 122px !important;
}
</style>
